import { withWindow } from '@shared/utils/withWindow';
import qsUtils from '@shared/core/queryString';

/**
 * Retained on mount since preview could push/pop navigation entries
 * which could result in the query params being removed.
 */
const previewQueryParamsOnMount = {
  preview: qsUtils.getValueString('preview'),
  ctx: qsUtils.getValueString('ctx'),
  view: qsUtils.getValueString('view'),
};

/**
 * Determines whether the event design draft should be used based on URL query params.
 * Returns true only when rendering in a website designer preview context.
 */
export const shouldUseEventDesignDraft = () =>
  withWindow<boolean>(
    () => previewQueryParamsOnMount.view === 'draft' || (previewQueryParamsOnMount.preview === 'true' && previewQueryParamsOnMount.ctx === 'websiteDesigner'),
    false,
  );
